import script from "./P9Select.vue?vue&type=script&setup=true&lang=js"
export * from "./P9Select.vue?vue&type=script&setup=true&lang=js"

import "./P9Select.vue?vue&type=style&index=0&id=383641c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383641c0"]])

export default __exports__